import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import IntegerField from '@shared/fields/integer-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';
import LocationField from '@shared/fields/location-field';
import { TeamField } from '@modules/team/team-field';
import BooleanField from '@shared/fields/boolean-field';

function label(name) {
  return i18n(`entities.game.fields.${name}`);
}

// function enumeratorLabel(name, value) {
//   return i18n(`entities.game.enumerators.${name}.${value}`);
// }

const fields = ({ dateFormat, timeFormat }) => ({
  id: new IdField('id', label('id')),
  awayTeam: TeamField.relationToOne('awayTeam', label('awayTeam'), {}),
  homeTeam: TeamField.relationToOne('homeTeam', label('homeTeam'), {}),
  awayTeamScore: new IntegerField('awayTeamScore', label('awayTeamScore')),
  homeTeamScore: new IntegerField('homeTeamScore', label('homeTeamScore')),
  isTimeAssigned: new BooleanField('isTimeAssigned', label('isTimeAssigned')),
  timestamp: new DateTimeField('timestamp', label('timestamp'), { "required": true, dateFormat, timeFormat }),
  date: new DateTimeField('date', label('date'), { "required": true, dateFormat, timeFormat }),
  hour: new StringField('hour', label('hour'), { "required": true }),
  duration: new StringField('duration', label('duration'), { "required": true }),
  location: new LocationField('location', label('location'), { "required": true }),
  locationInfo: new StringField('locationInfo', label('locationInfo'), {}),
  status: new EnumeratorField('status', label('status'), getSharedEnumeratorField('gameStatus'), { required: true }),
  type: new EnumeratorField('type', label('type'), getSharedEnumeratorField('gameType'), { required: true }),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),
  results: new StringField('results', label('results'), {}),
  
  dateRange: new DateTimeRangeField(
      'dateRange',
      label('dateRange'),
  ),
  teamToFilter: TeamField.relationToOne('teamToFilter', label('teamToFilter'), {}),
  regularSeasonRound: new StringField('regularSeasonRound', label('regularSeasonRound')),
  playoff: new StringField('playoff', label('playoff')),
});

export class GameModel extends GenericModel {
  constructor({ dateFormat, timeFormat } = {}) {
    super();

    this.dateFormat = dateFormat;
    this.timeFormat = timeFormat;
}

fields() {
    const { dateFormat, timeFormat } = this;
    return fields({ dateFormat, timeFormat });
}

presenter(row, fieldName) {
    const fields = this.fields();

    if (!fields[fieldName]) {
        throw new Error(`${fieldName} not found`);
    }

    return fields[fieldName].forPresenter(
        row[fields[fieldName].name],
    );
}
}